import React, { useState, useEffect, useRef } from "react";
import { formatMoneda } from "../../../util/varios";
import { Mensaje } from "../../mensajes2";

import { Dimmer } from "../../spinner";

import useTable from "../../useTable";
import axios from "axios";
import { ActualizarPublicidad } from "./modalAgregarPublicidad";

function TablaRegistro(props) {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const headCells = [
    {
      id: "",
      label: "CODIGO",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "",
      label: "DESCRIPCIÓN DE PUBLICIDAD COMERCIAL",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "",
      label: "ÁREA/UNID.",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "",
      label: "MONTO A PAGAR",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "",
      label: "CANCELADA",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
    {
      id: "",
      label: "OPCIONES",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
    },
  ];

  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
  const [ipMac, setIpMac] = useState({
    ip: localStorage.getItem("ip"),
    mac: localStorage.getItem("mac"),
  });
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [anio, setAnio] = useState();
  const txtAnio = useRef();
  const [total, setTotal] = useState(0.0);
  const [totalc, setTotalC] = useState(0.0);
  const [totald, setTotalD] = useState(0.0);
  const [valort, setValort] = useState(0.0);
  const [valorp, setValorp] = useState(0.0);
  const [valorpor, setValorpor] = useState(0.0);
  const [annio, setAnnio] = useState();
  const [publicidad, setPublicidad] = useState();
  const [tpublicidad, setTpublicidad] = useState();
  const [valorut, setValorut] = useState();
  const [configp, setConfigp] = useState();

  const blanquearCampos = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setPublicidad();
    setTpublicidad();
    setTotal(0.0);
    setTotalC(0.0);
    setTotalD(0.0);
    setValorp(0.0);
    setValorpor(0.0);
    setValort(0.0);
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const onChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;

    if (name === "anioTasa") {
      setAnnio(value);
      if (value !== "") {
        seleccionarDetalle(props.idcomercio, value);
        blanquearCampos();
      } else if (value === "") {
        seleccionarDetalle(props.idcomercio, value);
        blanquearCampos();
      }
    }
  };

  const seleccionarDetalle = (id, nanio) => {
    let nomtab = "publicidad";
    let idcom = "idcomercio";

    let endpoint = `${op.conexion}/api/publicidad/consultpublicidad?nomtab=${nomtab}&nomid=${idcom}&id=${id}&nanio=${nanio}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          setAnnio(nanio);

          let mas = 0.0;
          let desc = 0.0;

          for (var i = 0; i < response.data.length; i++) {
            mas = parseFloat(response.data[i].monto);
            desc = desc + mas;
            setTotal(desc);
            if (response.data[i].cancelada === true) {
              setTotalC(desc);
            } else if (
              response.data[i].cancelada === false ||
              response.data[i].cancelada === null
            ) {
              setTotalD(desc);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarRegistro = (idpublicidad) => {
    let campos = "*";
    let nomtab = "publicidad";
    let nomid = "idpublicidad";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idpublicidad}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idpublicidad > 0) {
            setPublicidad(response.data);
            seleccionarTipoPublicidad(response.data);
          } else {
            seleccionarTipoPublicidad(response.data);
          }

          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarTipoPublicidad = (data) => {
    let campos = "*";
    let nomtab = "tipopublicidad";
    let nomid = "idtipopublicidad";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idtipopublicidad}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idtipopublicidad > 0) {
            setTpublicidad(response.data);
            setMostrar5(true);
          } else {
            setMostrar5(true);
          }

          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarConfiguracion = () => {
    let endpoint = op.conexion + "/api/publicidad/configpublicidad";

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setConfigp(response.data);
          if (response.data.factorcalculo !== null) {
            SelectValorUT(response.data.factorcalculo);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const SelectValorUT = (factorcalculo) => {
    let tipo = (factorcalculo - 3).toString();
    let m = parseInt(fechaSistema.substring(6, 8));
    let a = parseInt(fechaSistema.substring(1, 5));

    var descripcion = "";
    descripcion =
      tipo === "0"
        ? "Petros"
        : tipo === "1"
          ? "Sueldo Minimo"
          : tipo === "2"
            ? "UCAMP"
            : "";

    let endpoint = `${op.conexion}/api/publicidad/valorut?factorcalculo=${factorcalculo}&anio=${a}&mes=${m}&espiritu=${espiritu}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setValorut(response.data[0].valor);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto:
                "El valor del " +
                descripcion +
                " para el año " +
                a +
                " del mes en curso no esta definido",
              icono: "informacion",
            });

            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const handleCloseMensa = () => {
    setMostrar(false);
    blanquearCampos();
  };

  useEffect(() => {
    let anioact = JSON.parse(localStorage.getItem("anioactu"));
    var nanio = [];
    var aini = parseInt(anioact) - 7;
    var afin = parseInt(anioact);

    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);
    seleccionarConfiguracion();

    seleccionarDetalle(props.idcomercio, parseInt(anioact));
  }, []);

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const opciones = (ope, id) => (event) => {
    event.preventDefault();
    blanquearCampos();

    if (txtAnio.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Debe seleccionar un año",
        icono: "informacion",
      });

      txtAnio.current.focus();
    } else {
      if (ope === 1) {
        if (props.status === 0 || props.status === null) {
          setMensaje({
            mostrar: true,
            titulo: "Notificacion",
            texto:
              "No puede Incluir Pulicidad para el Contribuyente: " +
              props.nombre +
              "Ya que el mismo se encuentra INACTIVO",
            icono: "informacion",
          });
        } else {
          setMostrar5(true);
          setOperacion(1);
          blanquearCampos();
        }
      } else if (ope === 2) {
        setOperacion(2);
        seleccionarRegistro(id);
      } else if (ope === 3) {
        if (props.status === 0 || props.status === null) {
          setMensaje({
            mostrar: true,
            titulo: "Notificacion",
            texto:
              "No puede Eliminar la Pulicidad para el Contribuyente: " +
              props.nombre +
              "Ya que el mismo se encuentra INACTIVO",
            icono: "informacion",
          });
        } else {
          setOperacion(3);
          seleccionarRegistro(id);
        }
      }
    }
  };

  return (
    <div className="card">
      <ActualizarPublicidad
        show={mostrar5}
        petro={props.petro}
        publicidad={publicidad}
        operacion={operacion}
        valorut={valorut}
        factor={configp}
        tpublicidad={tpublicidad}
        idcomercio={props.idcomercio}
        annio={annio}
        onRederizar={seleccionarDetalle}
        onHideCancela={cerrarModalActualizar}
        factorCambio={props.factorCambio}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>

      <div className="card-body">
        <div className="content">
          <div className="">
            <div className="row col-md-12 mx-auto">
              <div className="col-md-6">
                <div
                  className="input-group input-group-sm mb-3"
                  style={{ margin: 0, height: 27 }}
                >
                  <div className="input-group-prepend" style={{ width: 40 }}>
                    <span className="input-group-text w-100">Año: </span>
                  </div>
                  <select
                    name="anioTasa"
                    ref={txtAnio}
                    onChange={onChange}
                    className="form-control col-md-4"
                  >
                    {anio &&
                      anio.map((a) => (
                        <option key={a.anio} value={a.anio}>
                          {a.anio}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-4"></div>

              <div className="col-md-2">
                <div className="col-md-12">
                  <button
                    style={{ marginBottom: "10px" }}
                    onClick={opciones(1, "")}
                    className="btn col-md-12 btn-primary btn-sm rounded-pill"
                  >
                    <i className="fas fa-plus">
                      <small> INCLUIR</small>
                    </i>{" "}
                  </button>
                </div>
              </div>

              <div
                className="col-md-12"
                style={{ margin: "auto", marginTop: "1%" }}
              >
                <TblContainer>
                  <TblHead />

                  <tbody>
                    {records &&
                      recordsAfterPagingAndSorting().map((item, index) => (
                        <tr
                          key={item.idcomercio}
                          style={{ padding: "0", height: "40px" }}
                        >
                          <td
                            ssName="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "10px",
                            }}
                          >
                            {item.codigoordenanza}
                          </td>
                          <td
                            ssName="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "160px",
                            }}
                          >
                            {item.descripcion}
                          </td>
                          <td
                            ssName="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "80px",
                            }}
                          >
                            {formatMoneda(
                              item.cantidad
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}{" "}
                          </td>
                          <td
                            ssName="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "80px",
                            }}
                          >
                            {formatMoneda(
                              (item.monto * props.factorCambio)
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}{" "}
                          </td>
                          <td
                            ssName="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "80px",
                            }}
                          >
                            {item.cancelada === true ? "SI" : "NO"}{" "}
                          </td>

                          <td
                            ssName="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "40px",
                            }}
                          >
                            <button
                              onClick={opciones(2, item.idpublicidad)}
                              className="btn btn-warning btn-sm rounded-circle"
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                            &nbsp;
                            <button
                              onClick={opciones(3, item.idpublicidad)}
                              className="btn btn-danger btn-sm rounded-circle"
                            >
                              <i className="fa fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </div>
              <div className="row border rounded mx-auto py-4">
                <div className="input-group input-group-sm mb-3 col-md-4">
                  <div className="input-group-prepend" style={{ width: 150 }}>
                    <span className="input-group-text w-100">
                      Monto Total Bs:{" "}
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={true}
                    maxLength="10"
                    value={formatMoneda(
                      total.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                    className="form-control col-md-6"
                  />
                </div>
                <div className="input-group input-group-sm mb-3 col-md-4">
                  <div className="input-group-prepend" style={{ width: 150 }}>
                    <span className="input-group-text w-100">
                      Monto Pagado Bs:{" "}
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={true}
                    maxLength="10"
                    value={formatMoneda(
                      totalc.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                    name="montoanual"
                    className="form-control col-md-6"
                  />
                </div>
                <div className="input-group input-group-sm mb-3 col-md-4">
                  <div className="input-group-prepend" style={{ width: 150 }}>
                    <span className="input-group-text w-100">
                      Monto por Pagar Bs:{" "}
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={true}
                    maxLength="10"
                    value={formatMoneda(
                      totald.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                    name="montoanual"
                    className="form-control col-md-6"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row"></div>
      </div>
    </div>
  );
}

export default TablaRegistro;
